import { render, staticRenderFns } from "./ProductCarousel.vue?vue&type=template&id=29b50a54&scoped=true&"
import script from "./ProductCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProductCarousel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductCarousel.vue?vue&type=style&index=1&id=29b50a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b50a54",
  null
  
)

export default component.exports